import s from './Policy.module.scss';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Helmet } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.min.css';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import titleImage from "../../assets/images/titleImage.png";
import React, {useEffect, useState} from "react";
import axios from "axios";

// const breadcrumbs = [
//     { label: 'ホーム', link: '/' },
//     { label: '予約規定' },
// ];

const Policy = () => {
    const breadcrumbItems = [
        { name: 'ホーム ', link: '/' },
        { name: '予約規定'}
    ];
    const [policies, setPolicies] = useState([]);
    const [loadingPolicies, setLoadingPolicies] = useState(true);
    useEffect(() => {
        const fetchPolicies = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_LOCAL_URL}policies`
                );

                setPolicies(
                    (response.data || [])
                        .filter(p => p.is_active)
                        .sort((a, b) => a.sort_order - b.sort_order)
                );
            } catch (err) {
                console.error(err);
            } finally {
                setLoadingPolicies(false);
            }
        };

        fetchPolicies();
    }, []);
    return (
        <>
            <Helmet>
                <title>予約規定 | 初めての方へ</title>
                <meta name="description" content="予約規定 | 初めての方へ" />
            </Helmet>

            <div className={s.root}>
                {/*<SubHeader title="予約規定" breadcrumbs={breadcrumbs} />*/}
                <div className={"row mt-3"}>
                    <div className={"col-12"}>
                        <Breadcrumb items={breadcrumbItems}/>
                        <div className={s.titleContainer}>
                            <h2><img className={s.titleImage} src={titleImage}/>予約規定 | 初めての方へ</h2>
                        </div>
                    </div>
                </div>
                <div className="container py-5">

                    {/* Intro */}
                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body p-4">
                            <h2 className="mb-3">ご予約前に必ずご確認ください</h2>

                            <p>最新の予約規定はこちらです。</p>
                            <p>ご返金の必要があると当社が判断した場合、現金またはクレジットカードへ返金となります。</p>

                            <div className="alert alert-warning mt-3">
                                <strong>重要：</strong>
                                為替変動による返金差額は補償しておりません。
                            </div>

                            <div className="alert alert-danger">
                                12月25日・1月1日はキャンセル換算時間に含みません。
                            </div>
                        </div>
                    </div>

                    {/* Contact */}
                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body p-4">
                            <h3>緊急連絡先</h3>

                            <p>飛行機遅延・欠航の場合はすぐにご連絡ください。</p>

                            <div className="d-flex flex-wrap gap-3 mt-3">
                                <a
                                    href="tel:+61740412583"
                                    className="btn btn-primary"
                                >
                                    📞 電話する
                                </a>

                                <a
                                    href="https://line.me/R/ti/p/%40dii1064j"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-success"
                                >
                                    LINEで連絡する
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Payment */}
                    <div className="card shadow-sm border-0 mb-4">
                        <div className="card-body p-4">
                            <h3>お支払い方法</h3>

                            <p>対応カード：</p>

                            <div className="d-flex gap-3 mb-3">
                                <img
                                    src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-visa.png"
                                    alt="Visa"
                                    width="50"
                                />
                                <img
                                    src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-master.png"
                                    alt="Master"
                                    width="50"
                                />
                                <img
                                    src="https://dev.mightyaussie.com/wp-content/uploads/2019/04/card-amex.png"
                                    alt="Amex"
                                    width="50"
                                />
                            </div>

                            <div className="alert alert-info">
                                現地払い可能なツアーもございます。
                            </div>
                        </div>
                    </div>

                    {/* Accordion */}
                    <div className="accordion" id="policyAccordion">

                        {loadingPolicies ? (
                            <div className="text-center py-4">
                                読み込み中...
                            </div>
                        ) : policies.length === 0 ? (
                            <div className="alert alert-info">
                                規定情報がありません。
                            </div>
                        ) : (
                            policies.map((policy, index) => (
                                <div
                                    className="accordion-item"
                                    key={policy.id}
                                >
                                    <h2 className="accordion-header">
                                        <button
                                            className={`accordion-button ${
                                                index !== 0 ? 'collapsed' : ''
                                            }`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#policy-${policy.id}`}
                                        >
                                            {policy.title}
                                        </button>
                                    </h2>

                                    <div
                                        id={`policy-${policy.id}`}
                                        className={`accordion-collapse collapse ${
                                            index === 0 ? 'show' : ''
                                        }`}
                                        data-bs-parent="#policyAccordion"
                                    >
                                        <div
                                            className="accordion-body"
                                            dangerouslySetInnerHTML={{
                                                __html: policy.content
                                            }}
                                        />
                                    </div>
                                </div>
                            ))
                        )}

                    </div>

                </div>
            </div>
        </>
    );
};

export default Policy;